import { forwardRef } from "react";
import { ButtonProps, Button } from "@mui/material";

/**
 * Wrapper for MUI Button that allows us to create unique buttons when needed, but still
 * allowing for out default style overrides to be applied (disableRipple and focus outlines) for
 * accessibility compliance issues.
 **/
export type ButtonBaseProps = Omit<
  ButtonProps,
  | "disableRipple"
  | "disableTouchRipple"
  | "disableFocusRipple"
  | "href"
  | "component"
>;

export const ButtonBase = forwardRef<
  HTMLAnchorElement | HTMLButtonElement,
  ButtonBaseProps
>((props, ref) => {
  const { sx, ...rest } = props;

  const baseProps = {
    disableRipple: true,
    sx: [
      {
        textTransform: "capitalize",
        "&:focus-visible": {
          zIndex: 1,
          outline: "3px solid",
          outlineColor: "black.main",
        },
      },
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      ...(Array.isArray(sx) ? sx : [sx]),
    ],
    ...rest,
  };

  return (
    <Button ref={ref as React.ForwardedRef<HTMLButtonElement>} {...baseProps}>
      {props.children}
    </Button>
  );
});

ButtonBase.displayName = "ButtonBase";
